import { render, staticRenderFns } from "./UserAnswers.vue?vue&type=template&id=61b42db4&"
import script from "./UserAnswers.vue?vue&type=script&lang=js&"
export * from "./UserAnswers.vue?vue&type=script&lang=js&"
import style0 from "./UserAnswers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserAnswers.vue"
export default component.exports